import React from 'react';

var Logout = function Logout(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 25 27"
  }, props), React.createElement("path", {
    d: "M21.086 12.5l-3.293-3.293 1.414-1.414 5.707 5.707-5.707 5.707-1.414-1.414 3.293-3.293H8.5v-2h12.586zM9.75 25v2H3.5A3.5 3.5 0 0 1 0 23.5v-20A3.5 3.5 0 0 1 3.5 0h6.25v2H3.5A1.5 1.5 0 0 0 2 3.5v20A1.5 1.5 0 0 0 3.5 25h6.25z"
  }));
};

export default Logout;